import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Route } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import createStore from '@kenetto/kenetto-redux'

import * as reducers from './redux/'
import { configurationBaseName } from './config'
import './index.css'

import { App } from './containers'

if (process.env.NODE_ENV !== 'production') {

}

const initialState = {
  auth: {
    auth1: { isAuthenticated: false }
  },
  user: {}
}

const myStore = createStore(configurationBaseName, reducers, initialState)

render(
  <Provider store={myStore.store}>
    <ConnectedRouter history={myStore.history}>
      <Route path='/' component={App} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js